import { WeatherDayDtoSchema } from "@weather/data/dto/weather-day.dto";
import { WeatherHourDtoSchema } from "@weather/data/dto/weather-hour.dto";
import * as z from "zod";

export const WeatherDtoSchema = z
    .object({
        forecast: z.object({
            station_id: z.number(),
            station_name: z.string().trim(),
            station_tz: z.string().trim().nullable(),
            days: z.array(WeatherDayDtoSchema),
            hours: z.array(WeatherHourDtoSchema),
        }),
    })
    .readonly();
export type WeatherDto = z.output<typeof WeatherDtoSchema>;
